/**
 * Hero pull-quote: left brand border panel for solution page heroes (wash SectionSurface).
 */
export default function HeroPullQuote({ children, eyebrow, className = '' }) {
  return (
    <figure className={`mx-auto mt-8 max-w-full px-4 text-left sm:max-w-3xl sm:px-0 ${className}`.trim()}>
      {eyebrow ? (
        <figcaption className="mb-2 text-xs font-semibold uppercase tracking-wider text-brand-600">
          {eyebrow}
        </figcaption>
      ) : null}
      <blockquote className="relative rounded-r-xl border-l-4 border-brand-700 bg-white/80 py-4 pl-6 pr-5 shadow-sm backdrop-blur-sm">
        <span
          className="pointer-events-none absolute left-4 top-2 font-serif text-3xl leading-none text-brand-200"
          aria-hidden="true"
        >
          &ldquo;
        </span>
        <p className="relative text-lg font-medium leading-relaxed text-ink-700">{children}</p>
      </blockquote>
    </figure>
  );
}
